<!-- <div class="item-container" [class.pickup]="record.pickupflg == 1"
  [class.isFile]="record.fileContent && record.fileContent.fileId"
> -->
<div class="item-container" [class.pickup]="record.pickupflg == 1"
>

  <ng-container *ngIf="isDockbn;then chohyou; else kiroku"></ng-container>
</div>

<ng-template #kiroku>
  <!-- <ng-container *ngIf="!(record.fileContent && record.fileContent.fileId); else file"> -->
  <ng-container>
    <a [routerLink]="['/home/detail',record.noteid,{ objkbn: record.objkbn, objcd: record.objcd }]"
      [class.handover]="handover">
      <div class="record-item">
        <dt>
          <span class="title no-font-scale">
            <span *ngIf="record.sdate && record.edate" class="time">
              {{ record.sdate | date: "HH:mm" }}
            </span>
            <img *ngIf="record.icon" src="data:image/png;base64,{{ record.icon }}" alt="{{ record.ttlnm }}" width="20"
              height="20" />
            <span class="name">{{ truncate(record.ttlnm, 8) }}</span>
          </span>
        </dt>
        <dd *ngIf="noteParam; else noNote">
          <lib-note-display [params]="noteParam"></lib-note-display>
        </dd>
        <!-- <dd *ngIf="noteParam" [class.half]="img">
          <lib-note-display [params]="noteParam"></lib-note-display>
        </dd> -->
        <!-- <ng-container *ngIf="img">
          <img [src]="img" class="img-stamp" />
        </ng-container> -->
      </div>
    </a>
  </ng-container>
</ng-template>

<ng-template #noNote>
  <!-- <div class="no-note">（記録なし）</div> -->
  <div  class="no-content">  表示するデータがありません。  </div>
</ng-template>

<ng-template #chohyou>
  <!-- facesheet?daicd=:daicd&ttlkbn=:ttlkbn&ttlcd=:ttlcd -->
  <a [routerLink]="['/home/facesheet']"
    [queryParams]="{ daicd: record.objcd, ttlkbn: record.ttlkbn, ttlcd: record.ttlcd, noteid: record.noteid }"
    [class.handover]="handover">
    <div class="record-item chohyou">
      <div class="icon">
        <mat-icon class="mat-icon-large" svgIcon="facesheet"></mat-icon>
      </div>
      <div class="content">
        <dt class="header koru">
          <span class="title no-font-scale">
            <span class="name">{{ record.ttlnm }}</span>
          </span>
        </dt>
        <dd>
          <div class="label">作成日</div>{{ record.sdate | date: "yyyy年M月d日" }}
        </dd>
      </div>
    </div>
  </a>
</ng-template>

<!-- <ng-template #file>
  <div [class.handover]="handover" (click)="handleViewFile()" style="cursor: pointer;">
    <div class="record-item chohyou file">
      <div class="icon">
        <mat-icon class="mat-icon-large" [svgIcon]="fileIcon"></mat-icon>
      </div>
      <div class="content">
        <dt class="header koru">
          <span class="title no-font-scale">
            <span class="name">{{ record.fileContent?.fileName || '' }}</span>
          </span>
        </dt>
        <dd>
          <div class="label">開始日</div>{{ record.sdate | date: "yyyy年M月d日" }}
        </dd>
      </div>
    </div>
  </div>
</ng-template> -->